<template id="challenge-card-content">
    <div class="content">
        <section :class="teamSize == individualTeamText ? 'bet1' : 'bet'">
            <span>Bet</span>
            <span class="bet-value">{{betValue}}</span>
        </section>
        <section class="team-size" v-if="teamSize != individualTeamText">
            <span>Team size</span>
            <span class="team-size-value">{{teamSize}}</span>
        </section>
        <section class="date-range">
            <span>Start Date: {{dateRange}}</span>
        </section>
    </div>
</template>

<script>
import { INDIVIDUAL_TEAM_TEXT } from '../constants';
export default {
  template: '#challenge-card-content',
  props: ['betValue', 'teamSize', 'dateRange'],
  data: function () {
    return {
      individualTeamText: INDIVIDUAL_TEAM_TEXT
    }
  }
}
</script>
